import { defineStore } from 'pinia'
import axios from "@/app/plugins/Axios";

import { useConfigStore } from '@/app/store/pinia/configuracoes'


// import listasApi from '@/app/services/listas';

import { hoje } from '@/app/helpers/utils';
import moment from 'moment';


export const useContasPagarStore = defineStore('contaspagar', {

  state: () => ({
    contaspagar: [],
    contapagar: {
      vencimento: hoje(),
      data_pagamento: hoje(),
      documento: "Pagamento",
      forma_pagamento: "Depósito Bancário",
      valor: 500,
      valor_pago: 0,
      dividir_parcelar: "Não",
      parcelas: 4,
      recorrencia: "Mensal",
      categoria_id: 135,
      fornecedor_id: 448,
    },
    filtro: {
      data: hoje().substr(0,7),
      fornecedor_id: null,
      situacao: "abertos",
      data_inicial: moment().startOf('month').format("YYYY-MM-DD"),
      data_final: moment().endOf('month').format("YYYY-MM-DD"),
      forma_de_pagamento: null
    },
    contas_selecionadas: [],
  }),

  actions: {

    zerarFiltro() {
      this.filtro = {
        data: hoje().substr(0,7),
        fornecedor_id: null,
        situacao: "abertos",
        data_inicial: moment().startOf('month').format("YYYY-MM-DD"),
        data_final: moment().endOf('month').format("YYYY-MM-DD"),
        forma_de_pagamento: null
      };
    },

    zerar() {


      const configStore = useConfigStore();


      function vencimento(filtro) {
        let [ano, mes] = filtro.data.split("-");
        const dia = new Date().getDate();
        const data = (new Date(Number(ano),Number(mes)-1, dia)).toISOString().substring(0,10)
        return data;
      }

      console.log('zerar', vencimento(this.filtro));
      this.contapagar = {
        vencimento: vencimento(this.filtro),
        data_pagamento: null,
        documento: "",
        forma_pagamento: "Depósito Bancário",
        valor: 0,
        valor_pago: 0,
        dividir_parcelar: "Não",
        parcelas: 1,
        recorrencia: "Mensal",
        categoria_id: configStore.configuracoes.CATEGORIA_CONTAS_PADRAO,
        fornecedor_id: 0,
      };
    },

    async abrir(contapagar) {
      const response = await axios.get(`contaspagar/${contapagar.id}`);
      this.contapagar = response.data.contapagar;
    },

    async salvar(conta) {
      console.log('salvar', conta);
      const response = await axios.post(`contaspagar`, conta);
      return response.data;
    },

    async atualizar(conta) {
      const response = await axios.patch(`contaspagar/${conta.id}`, conta);
      return response.data;
    },

    async pagar(conta) {
      const response = await axios.patch(`contaspagar/${conta.id}/pagar`, conta);
      return response.data;
    },

    async excluir(contapagar) {
      const response = await axios.post(`contaspagar/${contapagar.id}`, { excluir_repeticoes: contapagar.excluir_repeticoes });
      this.contaspagar = this.contaspagar.filter(item => item.id !== contapagar.id);
      return response.data;
    },

    async salvarContaPagarFromEstoque(contas, movimento_id) {
      const response = await axios.post(`contaspagar/${movimento_id}/estoque`, { contaspagar: contas });
      return response.data;
    },

    async listar(filtro) {
      const response = await axios.get(`contaspagar`, {
        params: filtro,
      });
      this.contaspagar = response.data;
    },

    limparContasPagar() {
      this.contaspagar = [];
    },




  },

})


